
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import AntiModal from '../../common/modal/AntiModal';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class ThankYou extends React.Component {

    static propTypes = {
        location: PropTypes.object
    };

    static contextTypes = {
        store: PropTypes.any,
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        document.title = 'Diamonds Direct Custom Design';
        document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
    }

    newTabNav(page) {
        let win = window.open(page, '_blank');
        win.focus();
    }

    userNav(page) {
        window.location.href = '/' + page;
    }

    internalNav(page) {
        this.context.router.push('/' + page);
    }

    render() {
        return <div className='ThankYou'>
            <div className='thankYouHeader'>Thank You!</div>
            <div className='thankYouBody'>
                <div className='thankYouBr'></div>
                <div className='tyText'>Thank you for submitting an appointment request! A member of our team will follow up shortly to finalize your appointment.</div>
                <div className='tyText' style={{display: 'none'}}>A member of our remote team will be in touch with you soon!</div>
                <div className='tyButtonRow'>
                    <div className={'tyButton tyButtonPrimary'} onClick={() => this.internalNav('/')}><div>CONTINUE SHOPPING</div></div>
                    <div className={'tyButton tyButtonPrimary'} onClick={() => this.internalNav('covid-19-updates')} style={{display: 'none'}}><div>COVID-19 UPDATES</div></div>
                    <div className={'tyButton'} onClick={() => this.userNav('gallery/engagement-rings?tabtype=setting')} style={{display: 'none'}}><div>SHOP ENGAGEMENT RINGS</div></div>
                    <div className={'tyButton'} onClick={() => this.userNav('gallery/wedding-bands/womens')} style={{display: 'none'}}><div>SHOP WEDDING BANDS</div></div>
                </div>
                <div className='tyHoursSection' style={{display: 'none'}}>
                    <div className='tyHoursHeader'>Please note, our Customer Service and Sales Hours are:</div>
                    <div className='tyHoursWrapper'>
                        <div className='tyHoursBlock'>
                            <div className='tyBlockDays'>Monday - Saturday</div>
                            <div className='tyBlockHours'>10am to 6pm</div>
                        </div>
                        <div className='tyHoursBlock'>
                            <div className='tyBlockDays'>Sunday</div>
                            <div className='tyBlockHours'>12pm to 6pm</div>
                        </div>
                    </div>
                    <div className='tyHoursTimezone'>(Eastern Time Zone)</div>
                </div>
                <div className='tyText' style={{display: 'none'}}>If you've contacted us after hours, we will reach out to you promptly at the start of our next business day.</div>
                <div className='tyText' style={{display: 'none'}}>We look forward to assisting you!</div>
            </div>
        </div>;
    }
}
export default ThankYou;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const ThankYouContainer = connect(
  mapStateToProps,
  allActionCreators
)(ThankYou);


// WEBPACK FOOTER //
// ./src/components/views/contact/ThankYou.jsx